var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.3 6.143c0-1.019.824-1.843 1.843-1.843h13.714c1.018 0 1.843.824 1.843 1.843v10.286a1.842 1.842 0 0 1-1.843 1.843H14.66l-2.078 3.116a.7.7 0 0 1-1.165 0L9.34 18.271H5.143A1.842 1.842 0 0 1 3.3 16.43V6.143ZM5.143 5.7a.442.442 0 0 0-.443.443v10.286c0 .245.197.443.443.443h4.571a.7.7 0 0 1 .582.311L12 19.738l1.703-2.555a.7.7 0 0 1 .583-.311h4.57a.442.442 0 0 0 .444-.443V6.143a.442.442 0 0 0-.443-.443H5.143Z"
})));
export { SvgChat as ReactComponent };
export default __webpack_public_path__ + "0e23c0536f1276305bf839a154a3de82.svg";